<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-message" icon-small title="مدیریت پیامک و ایمیل" color="accent">
			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">گزارش پیامک ها</v-tab>
					<v-tab :key="1">گزارش ایمیل ها</v-tab>
					<v-tab :key="2" v-if="area !== 'superadmin'">
						{{ isCloud ? 'شارژ پنل پیامک و تنظیمات' : 'تنظیمات پیامک' }}
					</v-tab>
					<v-tab :key="3" v-if="area !== 'superadmin'">{{ 'تنظیمات ایمیل' }}</v-tab>

					<v-tabs-items v-model="activeTab" touchless class="mt-3">
						<v-tab-item :key="0">
							<v-alert outlined v-if="!checkPermission('Sms') && area !== 'superadmin'" type="error">دسترسی به این بخش برای شما امکان پذیر نمی باشد</v-alert>
							<sms-list v-else :mobile="mobile" :autoLoad="autoLoad" :area="area" />
						</v-tab-item>
						<v-tab-item :key="1">
							<v-alert outlined v-if="(!checkPermission('Email') || !checkActivePart('email')) && area !== 'superadmin'" type="error">دسترسی به این بخش برای شما امکان پذیر نمی باشد</v-alert>
							<email-list v-else :email="email" :autoLoad="autoLoad" :area="area" />
						</v-tab-item>
						<v-tab-item :key="2" style="" v-if="area !== 'superadmin'">
							<v-alert outlined v-if="!checkPermission('Sms')" type="error">دسترسی به این بخش برای شما
								امکان پذیر نمی باشد</v-alert>
							<div v-else>
								<v-row class="flex-column sms-row mx-2" style="position: sticky; top: 0;z-index: 2;">
									<v-col cols="12" md="12" class="text-left py-0">
										<!-- <v-spacer/> -->
										<v-btn class="" color="secondary" dark @click="() => { selectedCategory = -1; dialogSmsPatternManager = true }">
											مدیریت قالب های پیامک
										</v-btn>
										<v-btn class="mr-2" color="blue" :loading="loading" dark @click="saveSmsSettings()">
											ذخیره تنظیمات
										</v-btn>
									</v-col>
								</v-row>
								<v-row justify="center" class="ma-0">
									<v-col cols="10">
										<v-form ref="smsForm" class="mx-2" lazy-validation>
											<v-card class="px-3 py-5 mb-3">
												<v-row class="flex-column sms-row">
													<v-col cols="12" class="text-center">
														در صورت تمایل می توانید برای ارسال پیامک ها، یکی از پنل های
														پیامکی زیر را انتخاب کنید:
													</v-col>
													<v-col cols="12" md="4" class="">
														<v-combobox v-model="appSettings.defaultSmsPanel" clearable required :items="smsPanels" label="انتخاب پنل پیامک" single-line return-object item-text="title" item-value="id" />
													</v-col>
													<v-col cols="12">
														<v-row v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 2">
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.username" label="نام کاربری ملی پیامک" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.password" label="کلمه عبور ملی پیامک" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.melliPayamakConfig.from" label="شماره خط ملی پیامک" />
															</v-col>
														</v-row>
														<v-row justify="center" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 3">
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.kaveNegarConfig.apiKey" label="کلید رابط (api-key) کاوه نگار" />
															</v-col>
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.kaveNegarConfig.sender" label="شماره خط کاوه نگار" />
															</v-col>
														</v-row>
														<v-row justify="center" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 6">
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.ipPanelConfig.apiKey" label="کلید رابط (api-key)" />
															</v-col>
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.ipPanelConfig.sender" label="شماره خط" />
															</v-col>
														</v-row>
														<v-row justify="center" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 8">
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.webOneConfig.apiKey" label="کلید رابط (api-key)" />
															</v-col>
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.webOneConfig.sender" label="شماره خط" />
															</v-col>
														</v-row>
														<v-row justify="center" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 9 && checkActivePart('smsPanels.bale')">
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.baleConfig.apiKey" label="توکن وب سرویس (API)" />
															</v-col>
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.baleConfig.botId" label="شناسه بازو" />
															</v-col>
														</v-row>
														<v-row justify="center" v-else-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 9 && !checkActivePart('smsPanels.bale')">
															<v-col cols="12" md="10">
																<v-alert outlined type="error">ماژول پیام رسان بله برای شما فعال نمی باشد</v-alert>
															</v-col>
														</v-row>
														<v-row v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 10">
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.hafezPayamConfig.userName" label="نام کاربری حافظ پیام" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.hafezPayamConfig.password" label="کلمه عبور حافظ پیام" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.hafezPayamConfig.portalCode" label="پرتال کد" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="appSettings.defaultSmsPanel && appSettings.defaultSmsPanel.id === 1">
													<v-col cols="6" class="pb-0">
														<v-text-field class="center-input" :disabled="true" v-model="appSettings.smsCredit" label="اعتبار فعلی پیامک شما (تومان)" required />
													</v-col>
													<v-col cols="6" class="text-center pt-0">
														<v-btn class="mx-auto" color="secondary" dark @click="addSmsCreditCharge">
															<v-icon dark>
																mdi-plus-circle-outline
															</v-icon>
															افزایش اعتبار
														</v-btn>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.isRememberSmsActive" label="پیامک های یادآوری فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
														<div class="grey--text" v-show="appSettings.isRememberSmsActive">
															پیامک ها راس چه ساعتی ارسال شوند؟
														</div>
														<date-picker v-show="appSettings.isRememberSmsActive" v-model="appSettings.dueDatedRememberSmsTime" type="time" />
													</v-col>
													<v-col cols="12">
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
																<v-checkbox color="secondary" v-show="appSettings.isRememberSmsActive" v-model="appSettings.isDueDateSmsActive" :label="'پیامک یادآوری روز سررسید ارسال شود؟'" />
															</v-col>
															<v-col cols="12" md="8" class="text-center pb-0 grey--text" v-show="appSettings.isDueDateSmsActive">
																قالب پیامک یادآوری سررسید:
															</v-col>
															<v-col cols="12" md="8" class="pt-0" v-show="appSettings.isDueDateSmsActive">
																<div class="d-flex align-center">
																	<v-combobox v-model="appSettings.dueDateRememberSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																	<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 0; dialogSmsPatternManager = true }">
																		افرودن قالب
																	</v-btn>
																</div>
																<sms-pattern :data="appSettings.dueDateRememberSmsPattern" :onlySample="true" />
															</v-col>
														</v-row>
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
																<v-checkbox color="secondary" v-show="appSettings.isRememberSmsActive" v-model="isBeforeDueDateSmsActive" :label="'پیامک یادآوری سررسید پیش از موعد ارسال شود؟'" />
															</v-col>
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
																<div class="grey--text" v-show="isBeforeDueDateSmsActive">
																	پیامک یادآوری سررسید پیش از موعد چند روز قبل از
																	سررسید ارسال شود؟
																</div>
																<v-text-field class="center-input" v-show="isBeforeDueDateSmsActive" v-model="appSettings.beforeDueDaysCount" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.beforeDueDaysCount >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
															</v-col>
															<v-col cols="12" md="8" class="text-center pb-0 grey--text" v-show="isBeforeDueDateSmsActive">
																قالب پیامک سررسید پیش از موعد:
															</v-col>
															<v-col cols="12" md="8" class="pt-0" v-show="isBeforeDueDateSmsActive">
																<div class="d-flex  align-center">
																	<v-combobox v-model="appSettings.beforeDueDateSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																	<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 0; dialogSmsPatternManager = true }">
																		افرودن قالب
																	</v-btn>
																</div>
																<sms-pattern :data="appSettings.beforeDueDateSmsPattern" :onlySample="true" />
															</v-col>
														</v-row>
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberSmsActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
																<div class="grey--text">
																	پیامک اقساط معوق چند روز پس از سررسید ارسال شود؟
																</div>
																<v-text-field class="center-input" v-model="appSettings.overDueDaysCount" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.overDueDaysCount >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
															</v-col>
															<v-col cols="12" class="d-flex justify-center align-center pt-0">
																<v-checkbox color="secondary" v-model="appSettings.overDueDayRemeberOnce" :label="'پیامک یادآوری معوق تا زمان وصول ارسال شود؟'" />
																<span v-if="appSettings.overDueDayRemeberOnce" class="mr-5 grey--text text-small" style="margin-top:-15px">هر چند روز؟</span>
																<v-text-field class="center-input mr-1 pt-0 mt-0" v-if="appSettings.overDueDayRemeberOnce" v-model="appSettings.overDueDayGapPeriod" style="max-width:75px" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.overDueDayGapPeriod >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
															</v-col>
															<v-col cols="12" md="8" class="text-center pb-0 grey--text">
																قالب پیامک اقساط معوق شده:
															</v-col>
															<v-col cols="12" md="8" class="pt-0">
																<div class="d-flex  align-center">
																	<v-combobox v-model="appSettings.overDueDateSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																	<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 0; dialogSmsPatternManager = true }">
																		افرودن قالب
																	</v-btn>
																</div>
																<sms-pattern :data="appSettings.overDueDateSmsPattern" :onlySample="true" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک ثبت قسط و تشکر:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.thanksPaymentSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 0; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.thanksPaymentSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک ورود به سیستم:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.loginSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 2; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.loginSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک رمز تاییدیه ثبت نام:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.registerOtpSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 4; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.registerOtpSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک خوش آمد ثبت نام:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.registerSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 3; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.registerSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('customerOrders')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک ثبت سفارش جدید:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.newOrderSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 6; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.newOrderSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('agentFactor')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک رمز برداشت از کیف پول جهت ثبت صورتحساب توسط نماینده:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.walletWithdrawOtpSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 8; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.walletWithdrawOtpSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('agentFactorGateway')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک واریز صورتحساب الکترونیکی توسط مشتری:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.agentFactorPaymentLinkSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 9; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.agentFactorPaymentLinkSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>


												<v-row class="flex-column sms-row" v-if="checkActivePart('agentFactor')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک اطلاعیه برداشت از کیف پول به مشتری توسط ثبت صورتحساب
														نماینده:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.walletWithdrawNotificationSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 8; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.walletWithdrawNotificationSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک کد تائیدیه امضا قرارداد:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.digitalSignOtpSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 11; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.digitalSignOtpSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک لینک امضا قرارداد:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.digitalSignLinkSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 10; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.digitalSignLinkSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک اطلاعیه ثبت موفق قرارداد:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.digitalSignCompleteSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 12; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.digitalSignCompleteSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک کد تائیدیه امضا قرارداد ضامن:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.thirdPersonDigitalSignOtpSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 13; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.thirdPersonDigitalSignOtpSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک لینک امضا قرارداد ضامن:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.thirdPersonDigitalSignLinkSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 14; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.thirdPersonDigitalSignLinkSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('digitalSign')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک اطلاعیه ثبت موفق قرارداد ضامن:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.thirdPersonDigitalSignCompleteSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 15; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.thirdPersonDigitalSignCompleteSmsPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="checkActivePart('loanRequest')">
													<v-col cols="12" md="8" class="text-center pb-0 grey--text">
														قالب پیامک اطلاعیه درخواست وام جدید:
													</v-col>
													<v-col cols="12" md="8" class="pt-0">
														<div class="d-flex align-center">
															<v-combobox v-model="appSettings.newLoanRequestNotificationSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
															<v-btn color="secondary" class="mr-2" x-small outlined @click="() => { selectedCategory = 16; dialogSmsPatternManager = true }">
																افرودن قالب
															</v-btn>
														</div>
														<sms-pattern :data="appSettings.newLoanRequestNotificationSmsPattern" :onlySample="true" />
														<v-text-field class="left-input" v-model="appSettings.newLoanRequestNotificationSmsReceiptors" label="موبایل گیرندگان (با کاما , جدا شوند)" />
													</v-col>
												</v-row>

											</v-card>
										</v-form>
									</v-col>
								</v-row>
							</div>
						</v-tab-item>
						<v-tab-item :key="3" style="" v-if="area !== 'superadmin'">
							<v-alert outlined v-if="!checkPermission('Email') || !checkActivePart('email')" type="error">دسترسی به این بخش برای شما امکان پذیر نمی باشد</v-alert>
							<div v-else>
								<v-row class="flex-column sms-row mx-2" style="position: sticky; top: 0;z-index: 2;">
									<v-col cols="12" md="12" class="text-left py-0">
										<!-- <v-spacer/> -->
										<v-btn class="" color="secondary" dark @click="dialogSmsPatternManager = true">
											مدیریت قالب ها
										</v-btn>
										<v-btn class="mr-2" color="blue" :loading="loading" dark @click="saveSmsSettings()">
											ذخیره تنظیمات
										</v-btn>
									</v-col>
								</v-row>
								<v-row justify="center" class="ma-0">
									<v-col cols="10">
										<v-form ref="smsForm" class="mx-2" lazy-validation>
											<v-card class="px-3 py-5 mb-3">
												<v-row class="flex-column sms-row">
													<v-col cols="12" class="text-center">
														در صورت تمایل می توانید برای ارسال ایمیل ها، یکی از روش های زیر
														را انتخاب کنید:
													</v-col>
													<v-col cols="12" md="4" class="">
														<v-combobox v-model="appSettings.defaultEmailPanel" clearable required :items="emailPanels" label="انتخاب سرویس ایمیل" single-line return-object item-text="title" item-value="id" />
													</v-col>
													<v-col cols="12">
														<v-row v-if="appSettings.defaultEmailPanel && appSettings.defaultEmailPanel.id === 2">
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.emailConfig.smtpHost" label="smtp host" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.emailConfig.smtpPort" label="smtp port" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.emailConfig.smtpUsername" label="smtp username" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.emailConfig.smtpPassword" label="smtp password" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="" v-model="appSettings.emailConfig.name" label="نام نمایشی" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.emailConfig.adminEmail" label="ایمیل ادمین" hint="گزارش روزانه به این ایمیل ارسال می شود" persistent-hint />
															</v-col>
														</v-row>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.isRememberEmailActive" label="ایمیل های یادآوری فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
														<div class="grey--text" v-show="appSettings.isRememberEmailActive">
															ایمیل ها راس چه ساعتی ارسال شوند؟
														</div>
														<date-picker v-show="appSettings.isRememberEmailActive" v-model="appSettings.dueDatedRememberEmailTime" type="time" />
													</v-col>
													<v-col cols="12">
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberEmailActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
																<v-checkbox color="secondary" v-show="appSettings.isRememberEmailActive" v-model="appSettings.isDueDateEmailActive" :label="'ایمیل یادآوری روز سررسید ارسال شود؟'" />
															</v-col>
															<v-col cols="12" md="6" class="text-center pb-0 grey--text" v-show="appSettings.isDueDateEmailActive">
																قالب ایمیل یادآوری سررسید:
															</v-col>
															<v-col cols="12" md="6" class="pt-0" v-show="appSettings.isDueDateEmailActive">
																<v-combobox v-model="appSettings.dueDateRememberSmsPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																<sms-pattern :data="appSettings.dueDateRememberEmailPattern" :onlySample="true" />
															</v-col>
														</v-row>
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberEmailActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0 pb-0">
																<v-checkbox color="secondary" v-show="appSettings.isRememberEmailActive" v-model="isBeforeDueDateEmailActive" :label="'ایمیل یادآوری سررسید پیش از موعد ارسال شود؟'" />
															</v-col>
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
																<div class="grey--text" v-show="isBeforeDueDateEmailActive">
																	ایمیل یادآوری سررسید پیش از موعد چند روز قبل از
																	سررسید ارسال شود؟
																</div>
																<v-text-field class="center-input" v-show="isBeforeDueDateEmailActive" v-model="appSettings.beforeDueDaysCount_Email" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.beforeDueDaysCount_Email >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
															</v-col>
															<v-col cols="12" md="6" class="text-center pb-0 grey--text" v-show="isBeforeDueDateEmailActive">
																قالب ایمیل سررسید پیش از موعد:
															</v-col>
															<v-col cols="12" md="6" class="pt-0" v-show="isBeforeDueDateEmailActive">
																<v-combobox v-model="appSettings.beforeDueDateEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																<sms-pattern :data="appSettings.beforeDueDateEmailPattern" :onlySample="true" />
															</v-col>
														</v-row>
														<v-row class="flex-column sms-row" v-show="appSettings.isRememberEmailActive">
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
																<div class="grey--text">
																	ایمیل اقساط معوق چند روز پس از سررسید ارسال شود؟
																</div>
																<v-text-field class="center-input" v-model="appSettings.overDueDaysCount_Email" :error-messages="errorMessages" maxlength="3" :rules="[() => appSettings.overDueDaysCount_Email >= 0 || 'تعداد روز نمی تواند کمتر از 0 باشد']" />
															</v-col>
															<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
																<v-checkbox color="secondary" v-model="appSettings.overDueDayRemeberOnce_Email" :label="'ایمیل یادآوری معوق تا زمان وصول هر روز ارسال شود؟'" />
															</v-col>
															<v-col cols="12" md="6" class="text-center pb-0 grey--text">
																قالب ایمیل اقساط معوق شده:
															</v-col>
															<v-col cols="12" md="6" class="pt-0">
																<v-combobox v-model="appSettings.overDueDateEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
																<sms-pattern :data="appSettings.overDueDateEmailPattern" :onlySample="true" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.isDailyReportEmailActive" label="ایمیل گزارش روزانه به ادمین فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center pt-0">
														<div class="grey--text" v-show="appSettings.isDailyReportEmailActive">
															ایمیل راس چه ساعتی ارسال شود؟
														</div>
														<date-picker v-show="appSettings.isDailyReportEmailActive" v-model="appSettings.dailyReportEmailTime" type="time" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="6" class="text-center pb-0 grey--text">
														قالب ایمیل ثبت قسط و تشکر:
													</v-col>
													<v-col cols="12" md="6" class="pt-0">
														<v-combobox v-model="appSettings.thanksPaymentEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
														<sms-pattern :data="appSettings.thanksPaymentEmailPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="6" class="text-center pb-0 grey--text">
														قالب ایمیل ورود به سیستم:
													</v-col>
													<v-col cols="12" md="6" class="pt-0">
														<v-combobox v-model="appSettings.loginEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
														<sms-pattern :data="appSettings.loginEmailPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="6" class="text-center pb-0 grey--text">
														قالب ایمیل رمز تاییدیه ثبت نام:
													</v-col>
													<v-col cols="12" md="6" class="pt-0">
														<v-combobox v-model="appSettings.registerOtpEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
														<sms-pattern :data="appSettings.registerOtpEmailPattern" :onlySample="true" />
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row">
													<v-col cols="12" md="6" class="text-center pb-0 grey--text">
														قالب ایمیل خوش آمد ثبت نام:
													</v-col>
													<v-col cols="12" md="6" class="pt-0">
														<v-combobox v-model="appSettings.registerEmailPattern" clearable required :items="smsPatterns" label="قالب را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
														<sms-pattern :data="appSettings.registerEmailPattern" :onlySample="true" />
													</v-col>
												</v-row>

											</v-card>
										</v-form>
									</v-col>
								</v-row>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
			</div>
		</material-card>

		<confirm-dlg ref="confirm" />

		<div class="py-3" />

		<v-dialog v-model="dialogSmsPatternManager" scrollable persistent max-width="750px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت قالب های پیامک و ایمیل</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsPatternManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-pattern-manager ref="smsPatternManager" v-if="dialogSmsPatternManager" @itemsUpdated="updatePatterns" :category="selectedCategory" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSmsCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ اعتبار پیامک</span></div>
					<v-spacer />
					<v-btn @click="dialogSmsCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<sms-credit-charge ref="smsCreditCharge" v-if="dialogSmsCreditCharge" @callbck="callbck_smsCreditCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { call, get } from 'vuex-pathify'

export default {
	name: 'MembersView',
	props: {
		email: { type: String },
		mobile: { type: String },
		autoLoad: { type: Boolean, default: true },
		area: { type: String, default: 'admin' },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
		'date-navigator': () => import('@/components/DateNavigator'),
		'sms-credit-charge': () => import('@/components/forms/SmsCreditCharge.vue'),
		'sms-pattern-manager': () => import('@/components/SmsPatternManager.vue'),
		'sms-pattern': () => import('@/components/SmsPattern.vue'),
		'sms-list': () => import('@/views/admin/SMSList.vue'),
		'email-list': () => import('@/views/admin/EmailList.vue')
	},
	data() {
		return {
			selectedCategory: 0,
			isBeforeDueDateSmsActive: false,
			isBeforeDueDateEmailActive: false,
			dialogSmsCreditCharge: false,
			dialogSmsPatternManager: false,
			errorMessages: '',
			time: '',
			appSettings: { dashboardSettings: {} },
			smsPatterns: [],
			activeTab: 0,
			loading: false,
			rowLoading: '',
			smsPanels: [
				{ id: 1, title: 'جت اقساط' },
				{ id: 2, title: 'ملی پیامک' },
				{ id: 3, title: 'کاوه نگار' },
				{ id: 6, title: 'IPPanel' },
				{ id: 8, title: 'وب وان' },
				{ id: 9, title: 'پیام رسان بله' },
				{ id: 10, title: 'حافظ پیامک' },
			],
			emailPanels: [
				{ id: 1, title: 'جت اقساط' },
				{ id: 2, title: 'سرویس شخصی' }
			],
		}

	},
	computed: {
		...get('siteConfig', [
			'isCloud'
		]),
	},
	created() {

	},
	mounted() {
		if (this.area !== 'superadmin') {
			this.loadAppSettings()
			this.loadSmsPatterns()
			if (!this.checkActivePart('smsPanels.hafezPayam')) {
				this.smsPanels = this.smsPanels.filter(x => x.id !== 10)
			}
		}
	},
	methods: {
		...call('appSettings/*'),
		saveSmsSettings() {
			this.loading = true
			if (!this.appSettings.isRememberSmsActive)
				this.appSettings.dueDatedRememberSmsTime = null
			if (!this.isBeforeDueDateSmsActive)
				this.appSettings.beforeDueDaysCount = 0
			if (!this.appSettings.isRememberEmailActive)
				this.appSettings.dueDatedRememberEmailTime = null
			if (!this.appSettings.isDailyReportEmailActive)
				this.appSettings.dailyReportEmailTime = null
			if (!this.isBeforeDueDateEmailActive)
				this.appSettings.beforeDueDaysCount_Email = 0
			var data = _.cloneDeep(this.appSettings)
			data.overDueDayRemeberOnce = !this.appSettings.overDueDayRemeberOnce
			data.isRememberSmsActive = !!this.appSettings.isRememberSmsActive
			data.overDueDayRemeberOnce_Email = !this.appSettings.overDueDayRemeberOnce_Email
			data.isRememberEmailActive = !!this.appSettings.isRememberEmailActive
			if (this.appSettings.defaultSmsPanel)
				data.defaultSmsPanel = this.appSettings.defaultSmsPanel.id
			if (this.appSettings.defaultEmailPanel)
				data.defaultEmailPanel = this.appSettings.defaultEmailPanel.id
			this.sync(data).then(x => {
				this.loading = false
				toast.success('اطلاعات با موفقیت ذخیره شد.')
			}).catch(err => {
				this.loading = false
				toast.error(err.message)
			})
		},
		loadAppSettings() {
			this.fetch({ force: true }).then(x => {
				this.appSettings = x
				this.isBeforeDueDateSmsActive = !!this.appSettings.beforeDueDaysCount
				this.appSettings.overDueDayRemeberOnce = !this.appSettings.overDueDayRemeberOnce
				this.appSettings.defaultSmsPanel = this.smsPanels.find(x => x.id == this.appSettings.defaultSmsPanel)
				this.isBeforeDueDateEmailActive = !!this.appSettings.beforeDueDaysCount_Email
				this.appSettings.overDueDayRemeberOnce_Email = !this.appSettings.overDueDayRemeberOnce_Email
				this.appSettings.defaultEmailPanel = this.emailPanels.find(x => x.id == this.appSettings.defaultEmailPanel)
			})
		},
		async addSmsCreditCharge() {
			await this.saveSmsSettings()
			this.dialogSmsCreditCharge = true
		},
		callbck_smsCreditCharge() {
			this.dialogSmsCreditCharge = false
		},
		loadSmsPatterns() {
			api.get('admin/smsPattern/list', null)
				.then(
					response => {
						this.smsPatterns = response.filter(x => x.status === 1)
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => {
				})
		},
		updatePatterns(items) {
			this.smsPatterns = items.filter(x => x.status === 1)
		}
	},
}
</script>
<style scoped>
.sms-row {
	justify-content: center;
	align-items: center;
	background-color: whitesmoke;
	border-radius: 10px;
	margin: 15px 0;
	padding: 10px 0;
	border: 1px solid #dca6e5;
}
</style>